import {
  Box,
  Button,
  Divider,
  makeStyles,
  Switch,
  Typography,
} from "@material-ui/core";
import { useStore } from "@roc/client-portal-shared/hooks";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: "400px",
  },
  applyButton: {
    width: "300px"
  }
}));

interface StatusFiltersProps {
  onApply: () => void;
}

export const StatusFilters = observer(({ onApply }: StatusFiltersProps) => {
  const { compToolStoreV2: compToolStore } = useStore();
  const { compToolFiltersStore } = compToolStore;

  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap="1rem"
      className={classes.root}
    >
      <Typography variant="body1" style={{ fontWeight: "bold" }}>
        Property Status
      </Typography>
      <Divider variant="fullWidth" />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1">Appraisals</Typography>
        <Switch
          name="appraisals"
          color="primary"
          checked={compToolFiltersStore.form.fields.SALETYPE.values.value?.length === 1}
          onChange={(ev) => compToolFiltersStore.onFieldsChange('SALETYPE', 'values', ev.target.checked ? ["sale (from appraisal)"] : [])} />
      </Box>
      <Divider variant="fullWidth" />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1">Active Listings</Typography>
        <Switch
          name="activeListings"
          color="primary"
          checked={compToolFiltersStore.form.fields.ACTIVE_LISTINGS.values.value?.length === 1}
          onChange={(ev) => compToolFiltersStore.onFieldsChange('ACTIVE_LISTINGS', 'values', ev.target.checked ? ["True"] : null)} />
      </Box>
      <Divider variant="fullWidth" />
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1">Sold Listings</Typography>
        <Switch
          name="soldListings"
          color="primary"
          checked={compToolFiltersStore.form.fields.IS_ACTIVE.values.value?.length === 0}
          onChange={(ev) => compToolFiltersStore.onFieldsChange('IS_ACTIVE', 'values', ev.target.checked ? [] : ["True"])} />
      </Box>
      <Divider variant="fullWidth" />
      {/* <Box display="flex" justifyContent="space-between">
        <Typography variant="body1">Under Contract</Typography>
        <Switch
          name="underContract"
          color="primary"
          checked={compToolFiltersStore.form.fields.UNDER_CONTRACT.values.value?.length === 1}
          onChange={(ev) => compToolFiltersStore.onFieldsChange('UNDER_CONTRACT', 'values', ev.target.checked ? ["True"] : ["True", "False"])} />
      </Box>
      <Divider variant="fullWidth" /> */}
      {/* <Box display="flex" justifyContent="space-between">
        <Typography variant="body1">Distressed</Typography>
        <Switch
          name="distressed"
          color="primary"
          checked={compToolFiltersStore.form.fields.DISTRESSED.values.value?.length === 1}
          onChange={(ev) => compToolFiltersStore.onFieldsChange('DISTRESSED', 'values', ev.target.checked ? ["True"] : ["True", "False"])} />
      </Box>
      <Divider variant="fullWidth" /> */}
      <Box display="flex" justifyContent="space-between">
        <Typography variant="body1">Flips</Typography>
        <Switch
          name="flips"
          color="primary"
          checked={compToolFiltersStore.form.fields.WAS_FLIPPED.values.value?.length === 1}
          onChange={(ev) => compToolFiltersStore.onFieldsChange('WAS_FLIPPED', 'values', ev.target.checked ? ["True"] : null)} />
      </Box>
      <Divider variant="fullWidth" />
      <Box display="flex" justifyContent="center">
        <Button color="primary" variant="outlined" className={classes.applyButton} onClick={() => onApply && onApply()}>Apply</Button>
      </Box>
    </Box>
  );
});
